'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'door-open';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f52b';
var svgPathData = ['M80 64l0 400 192 0 0-400c0-8.8-7.2-16-16-16L96 48c-8.8 0-16 7.2-16 16zM240 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M96 48l160 0c8.8 0 16 7.2 16 16l0 400-192 0 0-400c0-8.8 7.2-16 16-16zM80 512l216 0c13.3 0 24-10.7 24-24l0-424c0-5.5-.7-10.9-2-16l34 0c8.8 0 16 7.2 16 16l0 424c0 13.3 10.7 24 24 24l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-400c0-35.3-28.7-64-64-64l-88 0 0 .5c-2.6-.3-5.3-.5-8-.5L96 0C60.7 0 32 28.7 32 64l0 400-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0zm96-256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDoorOpen = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;